import { render, staticRenderFns } from "./MappingZaloUser.vue?vue&type=template&id=37c0ac66"
import script from "./MappingZaloUser.vue?vue&type=script&lang=js"
export * from "./MappingZaloUser.vue?vue&type=script&lang=js"
import style0 from "./MappingZaloUser.vue?vue&type=style&index=0&id=37c0ac66&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports